import { Text } from '@chakra-ui/react'

import type { FormBlock } from '@/components/UI/Form/types'

export default function getAutoJoinWorldFormInput({
  worldTitleToRegisterFor,
  sessionOrSeries,
}: {
  worldTitleToRegisterFor: string
  sessionOrSeries: 'series' | 'session'
}): FormBlock {
  return {
    type: 'content',
    display: 'display',
    name: 'register_for_world',
    content: (
      <Text color="fg.muted">
        By registering for this {sessionOrSeries}, you will be automatically added to the{' '}
        {worldTitleToRegisterFor} subworld.
      </Text>
    ),
    size: 6,
  }
}
